import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { History } from "lucide-react";
import { DatePickerTR } from "@/components/ui/date-picker-tr";

// "Devir Paketi" — sistem öncesi satılmış paketin kalan derslerini girmek için
export const TransferPackageFields = ({ enabled, onToggle, usedSessions, onUsedChange, endDate, onEndDateChange, totalSessions = 0, testIdSuffix = "" }) => {
  const used = parseInt(usedSessions || 0) || 0;
  const remaining = Math.max(0, totalSessions - used);
  return (
    <div className={`rounded-xl border p-3 space-y-3 transition-colors ${enabled ? "border-violet-300 bg-violet-50" : "border-slate-200"}`} data-testid={`transfer-package-block${testIdSuffix}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-start gap-2">
          <History className="w-4 h-4 text-violet-600 mt-0.5" />
          <div>
            <p className="font-medium text-navy text-sm">Devir Paketi (Sistem öncesi satış)</p>
            <p className="text-xs text-grey">Daha önce satılmış ve kısmen kullanılmış paketi aktarın.</p>
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={onToggle} data-testid={`transfer-package-toggle${testIdSuffix}`} />
      </div>
      {enabled && (
        <div className="space-y-2">
          <Label className="text-sm">Daha önce yapılan ders sayısı</Label>
          <Input
            type="number"
            min="0"
            max={Math.max(0, totalSessions - 1)}
            value={usedSessions}
            onChange={(e) => onUsedChange(e.target.value)}
            className="rounded-xl bg-white"
            data-testid={`transfer-used-sessions-input${testIdSuffix}`}
          />
          {totalSessions > 0 && (
            <p className="text-xs text-violet-700" data-testid={`transfer-remaining-preview${testIdSuffix}`}>
              Yapılan {used} / Kalan {remaining} / Toplam {totalSessions} ders
            </p>
          )}
          <Label className="text-sm">Bitiş tarihi</Label>
          <DatePickerTR
            value={endDate}
            onChange={(ds) => onEndDateChange(ds || "")}
            returnDateString
            placeholder="Boş bırakılırsa geçerlilik süresiyle hesaplanır"
            data-testid={`transfer-end-date${testIdSuffix}`}
          />
          <ul className="text-xs text-violet-800 space-y-1 list-disc pl-4">
            <li>Satış tarihi olarak gerçek (eski) satış tarihini seçin. Paketin süresi dolmuş başlamaması için bitiş tarihini bugünden sonraya seçin.</li>
            <li>Satış fiyatı paketin gerçek toplam ücreti olmalı, kalan derslerin primi buradan hesaplanır.</li>
            <li>Önceden ödenen tutar "ödendi" sayılır ama gelir raporlarına girmez. Önceki dersler için prim yazılmaz.</li>
          </ul>
        </div>
      )}
    </div>
  );
};
